export default "__VITE_ASSET__Diygq0c1__"